export const orderStatus = {
  SEQUENCING_ORDER: '测序订单',
  PRODUCT_ORDER: '分子产品订单',
  GENE_ORDER: '基因订单',
  CORE_PROJECT_ORDER: ' 项目订单',
  PRIMER_ORDER: '引物合成订单',
  HIGH_THROUGHPUT: '高通量订单',
  GENE_REGULATION: '基因功能订单',
  POINT_ORDER: '积分订单'
}



// WEBPACK FOOTER //
// ./src/utils/constants.js